<template>
  <div class="create-charge">
    <div class="content-title">
      <div class="content-title-text">统筹组</div>
    </div>
    <div class="gap"></div>
    <div class="charge-staff">
      <div class="detail-info-item">
        <div class="detail-info-label">统筹人</div>
        <div class="detail-info-value">
          <select-person :type="2" v-model="charger" title="设置统筹人" :activity="activity.id"></select-person>
        </div>
      </div>
      <div class="detail-info-item">
        <div class="detail-info-label">统筹小组</div>
        <div class="detail-info-value">
          <select-person :type="2" v-model="groupList" multiple title="添加统筹小组成员" :activity="activity.id"></select-person>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "CreateCharge",
        props: {
            user: Object,
            group: Array
        },
        computed: {
            activity() {
                return this.$store.getters.activity;
            },
            charger: {
                get() {
                    return this.user ? {...this.user} : null
                },
                set(val) {
                    this.$emit("user", val);
                }
            },
            groupList: {
                get() {
                    return this.group ? [...this.group] : null
                },
                set(val) {
                    this.$emit("group", val);
                }
            }
        }
    }
</script>

<style lang="less">

</style>
